import axios from "axios";
import { pbxAuthHeader } from "../authservice/auth-header";

const API_URL = "https://d82gbve725.execute-api.us-east-1.amazonaws.com/dev/";

class CompanyService {
  // ID SCAN CUSTOMER RELATED APIs

  // Get customer list
  getCustomerList() {
    return axios
      .get(API_URL + "id-scan/customer", {
        headers: pbxAuthHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // Add new customer
  addCustomer(data) {
    return axios
      .post(API_URL + "id-scan/customer", data, {
        headers: pbxAuthHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // Update costomer list
  updateCustomer(custmer_id, data) {
    return axios
      .patch(API_URL + "id-scan/customer/" + custmer_id, data, {
        headers: pbxAuthHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // Refresh customer code
  refreshCustomerCode(custmer_id, data) {
    return axios
      .patch(API_URL + "id-scan/customer/" + custmer_id, data, {
        headers: pbxAuthHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // Delete customer
  deleteCustomer(custmer_id) {
    return axios.delete(API_URL + "id-scan/customer/" + custmer_id, {
      headers: pbxAuthHeader(),
    });
  }

  //   GET ALL GUEST OCR DATA
  // Get call store guest ocr data list
  getOCRCustomerList(custmer_id, card_id) {
    return axios.delete(
      API_URL + "id-scan/guest-ocr-data?customer_id=" + custmer_id,
      {
        headers: pbxAuthHeader(),
      }
    );
  }
}
export default new CompanyService();
